// 深拷贝
export function cloneDeep(obj) {
    var copy
    if (null == obj || 'object' != typeof obj) return obj
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date()
        copy.setTime(obj.getTime())
        return copy
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = []
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = cloneDeep(obj[i])
        }
        return copy
    }

    // Handle Function
    if (obj instanceof Function) {
        copy = function () {
            return obj.apply(this, arguments)
        }
        return copy
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {}
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = cloneDeep(obj[attr])
        }
        return copy
    }
    throw new Error("Unable to copy obj as type isn't supported ")
}

// 是否是电话
export function isPhone(tel) {
    if (!tel) {
        return false
    }
    let regu = /^1[3-9][0-9]{9}$/

    if (regu.test(tel)) {
        return true
    } else {
        return false
    }
}

// 是否是邮箱
export function isEmail(val) {
    if (!val) {
        return false
    }
    let regu = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (regu.test(val)) {
        return true
    } else {
        return false
    }
}

// 是否是数组
export function isArray(arg) {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
}

// 是否是对象
export function isObj(arg) {
    if (Object.prototype.toString.call(arg) === '[object Object]') {
        return true
    } else {
        return false
    }
}
